"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTwitterChannelsAsSelectInputOptions = exports.getTwitterChannels = exports.getFetchChannelsRequestStatus = exports.getChannels = void 0;

var _reselect = require("reselect");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getChannels = function getChannels(state) {
  return state.channels;
};

exports.getChannels = getChannels;
var getFetchChannelsRequestStatus = (0, _getRequestStatus.default)(_actions.ChannelActionTypes.FETCH_CHANNELS);
exports.getFetchChannelsRequestStatus = getFetchChannelsRequestStatus;
var getTwitterChannels = (0, _reselect.createSelector)([getChannels], function (channels) {
  return channels.filter(function (channel) {
    return channel.get('channelSlug') === 'twitter';
  });
});
exports.getTwitterChannels = getTwitterChannels;
var getTwitterChannelsAsSelectInputOptions = (0, _reselect.createSelector)([getTwitterChannels], function (twitterChannels) {
  return twitterChannels.reduce(function (acc, twitterChannel) {
    acc.push({
      text: "@" + twitterChannel.userName,
      value: "@" + twitterChannel.userName
    });
    return acc;
  }, []);
});
exports.getTwitterChannelsAsSelectInputOptions = getTwitterChannelsAsSelectInputOptions;